export default "__VITE_ASSET__DNb5T5mn__"